export default __webpack_public_path__ + "static/media/2503285.35bbe675.jpg";